import { jwtDecode } from 'jwt-decode';
import { JWTAccessToken } from '@justgiving/auth/es/types/AccessToken';

export function getUserIdFromCookie(authCookie: string) {
  const jwt = new URLSearchParams(authCookie).get('access_token');
  if (!jwt) {
    return null;
  }

  const decodedJwt = jwtDecode<JWTAccessToken>(jwt);
  return decodedJwt.sub;
}
